'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$21() {
  this.beN = null;
  this.beL = null;
  this.beM = false;
  this.beJ = null;
  this.beK = false;
  this.beO = false;
  this.beP = false;
  this.beN = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_PrestoRouter$$anon$21 as $c_Lpresto_PrestoRouter$$anon$21 };
$p = $c_Lpresto_PrestoRouter$$anon$21.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$21;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$21() {
}
export { $h_Lpresto_PrestoRouter$$anon$21 as $h_Lpresto_PrestoRouter$$anon$21 };
$h_Lpresto_PrestoRouter$$anon$21.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ac = (function() {
  return this.beN;
});
$p.t = (function() {
  if ((!this.beM)) {
    this.beL = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.beM = true;
  }
  return this.beL;
});
$p.ad = (function() {
  if ((!this.beK)) {
    this.beJ = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.beK = true;
  }
  return this.beJ;
});
$p.v = (function() {
  if ((!this.beP)) {
    this.beO = false;
    this.beP = true;
  }
  return this.beO;
});
$p.ab = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_PrestoRouter$$anon$21 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$21, "presto.PrestoRouter$$anon$21", ({
  NV: 1,
  a: 1,
  j: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$21 as $d_Lpresto_PrestoRouter$$anon$21 };
//# sourceMappingURL=presto.-Presto-Router$$anon$21.js.map
